<template>
  <thead class="bg-gray-50">
    <tr>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/2"
      >
        Name
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
      >
        Estimated Audience Size
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/2"
      >
        Source
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Created
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      />
    </tr>
  </thead>
</template>

<script>
export default {};
</script>
